define('SageDotCom/Components/Forms/GatedContent',[
    'jquery',
    'eventManager',
    'SageDotCom/DataLayer/tealium'
    
],
    function ($, eventManager, tealium, eventSchema) {
    function GatedContent(scope, formCampaignId) {
        // register page level analytics relating to forms
        var formEvent = {
            'page_form_exists': 'true',
            'page_form_content_name': formCampaignId,
            'page_form_campaign_name': '(not set)'
        };
        tealium.registerPageData(formEvent);
    }

    return function init(args) {
        return args.IsExperienceEditorEditing ? null : new GatedContent(args.scope, args.FormCampaignId);
    };
});
